<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex :class="productionHeader.id ? 'sm6' : 'sm12'">
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="checkDisable('complete') ? true : false"
                >
                  <v-text-field
                    slot="activator"
                    label="Issue Date"
                    type="text"
                    prepend-icon="event"
                    v-model="issueDate"
                    readonly
                    :rules="rules.required('Issue Date')"
                  ></v-text-field>
                  <v-date-picker
                    v-model="issueDate"
                    :rules="rules.required('Issue Date')"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="productionHeader.id">
                <v-text-field
                  name="issueNo"
                  label="Issue No"
                  type="text"
                  v-model="productionHeader.issueNo"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Production Name"
                  type="text"
                  v-model="productionHeader.name"
                  :rules="rules.lengthRequiredRules(100, 'Production name')"
                  :readonly="checkDisable('complete')"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  :items="shopList"
                  label="Shop"
                  v-model="productionHeader.shopId"
                  item-text="name"
                  item-value="id"
                  color="blue-grey lighten-2"
                  menu-props="auto"
                  :hide-no-data="true"
                  @change="setWarehouse()"
                  :rules="rules.required('Shop')"
                  :readonly="
                    checkDisable('progress') || checkRoleShop() ? true : false
                  "
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  :items="departmentList"
                  label="Department"
                  v-model="productionHeader.departmentId"
                  item-text="name"
                  item-value="id"
                  color="blue-grey lighten-2"
                  menu-props="auto"
                  :hide-no-data="true"
                  :rules="rules.required('Department')"
                  :readonly="checkDisable('complete')"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  type="text"
                  v-model="productionHeader.description"
                  :rules="rules.lengthRules(500, 'Description')"
                  :readonly="checkDisable('complete')"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-layout>
                  <v-flex
                    :class="
                      productionHeader.productionOrderNo ? 'sm10' : 'sm11'
                    "
                  >
                    <v-text-field
                      label="Choose Production Order No ..."
                      v-model="productionHeader.productionOrderAndPoNo"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm1 v-if="productionHeader.productionOrderNo">
                    <v-btn
                      color="red"
                      outline
                      icon
                      :disabled="checkDisable('progress') ? true : false"
                      @click="productionHeader.productionOrderNo = '', productionHeader.productionOrderAndPoNo = ''"
                    >
                      <v-icon>cancel</v-icon></v-btn
                    >
                  </v-flex>
                  <v-flex sm1>
                    <v-btn
                      color="primary"
                      outline
                      icon
                      :disabled="
                        checkDisable('complete') ||
                        productionHeader.productionOrderNo
                          ? true
                          : false
                      "
                      @click="showDialog('poNo')"
                    >
                      <v-icon>search</v-icon></v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm6>
                <v-layout>
                  <v-flex sm11>
                    <v-text-field
                      class="ml-1"
                      label="Choose EMR No ..."
                      v-model="productionHeader.emrNos"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm1 v-if="productionHeader.emrNos">
                    <v-menu
                      top
                      :close-on-content-click="false"
                      :nudge-width="250"
                      :nudge-left="250"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          icon
                          color="red"
                          outline
                          :disabled="checkDisable('complete') ? true : false"
                        >
                          <v-icon>cancel</v-icon>
                        </v-btn>
                      </template>

                      <v-card>
                        <v-card-title class="blue darken-3">
                          <span class="headline white--text">EMR Nos</span>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                          <div v-for="(emr, key) in selectedEmrList" :key="key">
                            <a v-text="emr.issueNo" />
                            <span>
                              <v-btn
                                icon
                                @click="clearEMRNos(emr)"
                                :disabled="
                                  !!oldEmrList &&
                                  !!oldEmrList.find(
                                    (v) => v.issueNo == emr.issueNo
                                  )
                                "
                              >
                                <v-icon color="red">cancel</v-icon>
                              </v-btn>
                            </span>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-menu>
                  </v-flex>
                  <v-flex sm1>
                    <v-btn
                      color="primary"
                      outline
                      icon
                      :disabled="checkDisable('complete') ? true : false"
                      @click="showDialog('emrNo')"
                    >
                      <v-icon>search</v-icon></v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm12>
                <v-layout>
                  <v-flex sm10>
                    <v-text-field
                      label="Choose RMR No ..."
                      v-model="productionHeader.rmrNos"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm1 v-if="productionHeader.rmrNos">
                    <v-menu
                      top
                      :close-on-content-click="false"
                      :nudge-width="250"
                      :nudge-left="250"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          icon
                          color="red"
                          outline
                          :disabled="checkDisable('progress') ? true : false"
                        >
                          <v-icon>cancel</v-icon>
                        </v-btn>
                      </template>

                      <v-card>
                        <v-card-title class="blue darken-3">
                          <span class="headline white--text">RMR Nos</span>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                          <div v-for="(rmr, key) in selectedRmrList" :key="key">
                            <a v-text="rmr.issueNo" />
                            <span>
                              <v-btn
                                icon
                                @click="clearEMRNos(rmr)"
                                :disabled="
                                  !!oldRmrList &&
                                  !!oldRmrList.find(
                                    (v) => v.issueNo == rmr.issueNo
                                  )
                                "
                              >
                                <v-icon color="red">cancel</v-icon>
                              </v-btn>
                            </span>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-menu>
                  </v-flex>
                  <v-flex sm1>
                    <v-btn
                      color="primary"
                      outline
                      icon
                      :disabled="checkDisable('complete') ? true : false"
                      @click="showDialog('rmrNo')"
                    >
                      <v-icon>search</v-icon></v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  label="Production Warehouse ..."
                  :items="warehouseList"
                  v-model="productionHeader.productionWarehouseId"
                  item-text="name"
                  item-value="id"
                  color="blue-grey lighten-2"
                  menu-props="auto"
                  :hide-no-data="true"
                  :rules="rules.required('Production warehouse')"
                  :disabled="
                    checkDisable('progress') || checkRoleWarehouse()
                      ? true
                      : false
                  "
                  @change="getWarehouseBin('Production')"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  label="Production Bin ..."
                  :items="productionBinList"
                  v-model="productionHeader.productionBinId"
                  item-text="name"
                  item-value="id"
                  color="blue-grey lighten-2"
                  menu-props="auto"
                  :hide-no-data="true"
                  @change="clearOldItems()"
                  :rules="rules.required('Production bin')"
                  :disabled="checkDisable('progress') ? true : false"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  label="Output Warehouse ..."
                  :items="warehouseList"
                  v-model="productionHeader.outputWarehouseId"
                  item-text="name"
                  item-value="id"
                  color="blue-grey lighten-2"
                  menu-props="auto"
                  :hide-no-data="true"
                  :rules="rules.required('Output warehouse')"
                  :disabled="
                    checkDisable('complete') || checkRoleWarehouse()
                      ? true
                      : false
                  "
                  @change="getWarehouseBin('Output')"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  label="Output Bin ..."
                  :items="outputBinList"
                  v-model="productionHeader.outputBinId"
                  item-text="name"
                  item-value="id"
                  color="blue-grey lighten-2"
                  menu-props="auto"
                  :hide-no-data="true"
                  :rules="rules.required('Output bin')"
                  :disabled="checkDisable('complete') ? true : false"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  label="Choose Status ..."
                  :items="statusList"
                  v-model="productionHeader.status"
                  item-text="label"
                  item-value="value"
                  menu-props="auto"
                  color="blue-grey lighten-2"
                  :rules="rules.required('Status')"
                  :readonly="checkDisable('finished')"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="wipPercent"
                  label="WIP Percent"
                  type="number"
                  v-model="productionHeader.wipPercent"
                  :rules="rules.geraterThanzeroPercentageRules('WIP Percent')"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  label="Choose Production Item Type ..."
                  :items="productionItemList"
                  v-model="productionHeader.productionItemId"
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  color="blue-grey lighten-2"
                  :hide-no-data="true"
                  :rules="rules.required('Production item')"
                  :disabled="checkDisable('complete') ? true : false"
                  @change="changeProductionItem"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  label="WIP Status"
                  :items="productionItemDetailList"
                  v-model="productionHeader.productionItemDetailId"
                  item-text="processName"
                  item-value="id"
                  menu-props="auto"
                  color="blue-grey lighten-2"
                  :rules="rules.required('WIP status')"
                  :disabled="checkDisable('complete') ? true : false"
                  @change="changeWIPStatus"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6 v-if="productionHeader.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="productionHeader.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="productionHeader.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="productionHeader.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="productionHeader.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="productionHeader.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <!--production detail list-->
              <v-flex
                sm12
                pt-3
                v-for="(meta, index) in itemListMeta"
                :key="index"
              >
                <v-card>
                  <v-card-title>
                    <span
                      class="headline font-weight-bold pr-3"
                      v-if="meta.outOrIn == 'IN'"
                      >Ingredient</span
                    >
                    <span class="headline font-weight-bold pr-3" v-else
                      >Output</span
                    >
                    <v-icon
                      large
                      @click="
                        (inOrOutItem = meta.outOrIn), showDialog('product')
                      "
                      :disabled="checkDisable('complete') ? true : false"
                      >add_circle</v-icon
                    >
                    <span class="subheading pl-5 pr-2 font-weight-medium"
                      >Total Amount:
                    </span>
                    <v-chip>
                      <span>{{ meta.totalAmount | decFormat(6) }}</span>
                    </v-chip>
                  </v-card-title>
                  <v-card-text>
                    <v-data-table
                      :headers="meta.outOrIn == 'IN' ? inHeaders : outHeaders"
                      :items="meta.itemList"
                      class="elevation-1"
                    >
                      <template v-slot:items="props">
                        <td>
                          <v-text-field
                            v-model="props.item.productCode"
                            type="text"
                            :rules="rules.lengthRequiredRules(20, 'Code')"
                            readonly
                            style="width: 200px"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="props.item.productName"
                            type="text"
                            :rules="rules.lengthRequiredRules(100, 'Name')"
                            readonly
                            style="width: 200px"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-autocomplete
                            v-if="meta.outOrIn == 'IN'"
                            v-model="props.item.qcNo"
                            :hide-no-data="true"
                            :items="props.item.stockQcNoDTOList"
                            item-text="qcNo"
                            item-value="qcNo"
                            color="blue-grey lighten-2"
                            menu-props="auto"
                            style="width: 200px"
                            @change="changeQCNo(props.item)"
                            :disabled="checkDisable('progress') && productionHeader.id && !props.item.isNew ? true : false"
                          ></v-autocomplete>
                          <v-text-field
                            v-else
                            v-model="props.item.qcNo"
                            type="text"
                            color="warning"
                            clearable
                            append-icon="search"
                            @click:clear="clearQCno(props.item)"
                            @click:append="openQCListDialog(props.item)"
                            :disabled="checkDisable('complete') ? true : false"
                            style="width: 200px"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-autocomplete
                            v-if="meta.outOrIn == 'IN'"
                            v-model="props.item.batchNo"
                            :hide-no-data="true"
                            :items="props.item.batchNoList"
                            item-text="batchNo"
                            item-value="batchNo"
                            color="blue-grey lighten-2"
                            menu-props="auto"
                            style="width: 200px"
                            @change="changeBatchNo(props.item)"
                            :disabled="checkDisable('progress') && productionHeader.id && !props.item.isNew ? true : false"
                          ></v-autocomplete>
                          <v-text-field
                            v-else
                            v-model="props.item.batchNo"
                            type="text"
                            :readonly="checkDisable('complete')"
                            style="width: 100px"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-menu
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                            :disabled="
                              meta.outOrIn == 'IN'
                                ? checkDisable('progress') && productionHeader.id && !props.item.isNew ? true : false
                                : checkDisable('complete')
                                ? true
                                : false
                            "
                          >
                            <v-text-field
                              slot="activator"
                              placeholder="MFG Date"
                              type="text"
                              prepend-icon="event"
                              v-model="props.item.mfgDate"
                              readonly
                              style="width: 120px"
                            ></v-text-field>
                            <v-date-picker
                              v-model="props.item.mfgDate"
                              @input="
                                meta.outOrIn == 'IN'
                                  ? calculateIngredientUnitCost(props.item)
                                  : ''
                              "
                            ></v-date-picker>
                          </v-menu>
                        </td>
                        <td>
                          <v-menu
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                            :disabled="
                              meta.outOrIn == 'IN'
                                ? checkDisable('progress') && productionHeader.id && !props.item.isNew ? true : false
                                : checkDisable('complete')
                                ? true
                                : false
                            "
                          >
                            <v-text-field
                              slot="activator"
                              placeholder="MFG Date"
                              type="text"
                              prepend-icon="event"
                              v-model="props.item.expDate"
                              readonly
                              style="width: 120px"
                            ></v-text-field>
                            <v-date-picker
                              v-model="props.item.expDate"
                              @input="
                                meta.outOrIn == 'IN'
                                  ? calculateIngredientUnitCost(props.item)
                                  : ''
                              "
                            ></v-date-picker>
                          </v-menu>
                        </td>
                        <td>
                          <v-autocomplete
                            :items="props.item.productUnits"
                            v-model="props.item.factorUnitName"
                            item-text="factorUnitName"
                            item-value="factorUnitName"
                            menu-props="auto"
                            color="blue-grey lighten-2"
                            :hide-no-data="true"
                            :rules="rules.required('Unit')"
                            :readonly="
                              meta.outOrIn == 'IN'
                                ? checkDisable('progress')
                                : checkDisable('complete')
                            "
                            @change="
                              initUnitCost(
                                props.item,
                                props.item.factorUnitName
                              )
                            "
                            style="width: 200px"
                          ></v-autocomplete>
                        </td>
                        <td>
                          <v-text-field
                            v-model="props.item.unitCost"
                            type="number"
                            :readonly="checkDisable('finished')"
                            :rules="rules.zeroUnitCostRules('Unit Cost')"
                            @input="changeUnitCost(meta.outOrIn)"
                            style="width: 180px"
                          ></v-text-field>
                        </td>
                        <td v-if="meta.outOrIn == 'IN'">
                          <v-text-field
                            v-model="props.item.poQty"
                            type="number"
                            readonly
                            style="width: 150px"
                          ></v-text-field>
                        </td>
                        <td v-if="meta.outOrIn == 'IN'">
                          <v-text-field
                            v-model="props.item.poUsageQty"
                            type="number"
                            :readonly="checkDisable('complete')"
                            style="width: 150px"
                            :rules="
                              status == 'DRAFT'
                                ? rules.zeroQtyRules('PO Usage Qty')
                                : rules.zeroUsageQtyRules(
                                    'PO UsageQty',
                                    props.item.oldPoUsageQty
                                  )
                            "
                          ></v-text-field>
                        </td>
                        <td v-if="meta.outOrIn == 'IN'">
                          <v-text-field
                            v-model="props.item.emrQty"
                            type="number"
                            readonly
                            style="width: 150px"
                          ></v-text-field>
                        </td>
                        <td v-if="meta.outOrIn == 'IN'">
                          <v-text-field
                            v-model="props.item.emrUsageQty"
                            type="number"
                            :readonly="checkDisable('complete')"
                            style="width: 150px"
                            :rules="
                              status == 'DRAFT'
                                ? rules.zeroQtyRules('EMR Usage Qty')
                                : rules.zeroUsageQtyRules(
                                    'EMR UsageQty',
                                    props.item.oldEmrUsageQty
                                  )
                            "
                          ></v-text-field>
                        </td>
                        <td v-if="meta.outOrIn == 'IN'">
                          <v-text-field
                            v-model="props.item.rmrQty"
                            type="number"
                            readonly
                            style="width: 150px"
                          ></v-text-field>
                        </td>
                        <td v-if="meta.outOrIn == 'IN'">
                          <v-text-field
                            v-model="props.item.rmrUsageQty"
                            type="number"
                            :readonly="checkDisable('complete')"
                            style="width: 150px"
                            :rules="
                              status == 'DRAFT'
                                ? rules.zeroQtyRules('RMR Usage Qty')
                                : rules.zeroUsageQtyRules(
                                    'RMR UsageQty',
                                    props.item.oldRmrUsageQty
                                  )
                            "
                          ></v-text-field>
                        </td>
                        <td v-if="meta.outOrIn == 'OUT'">
                          <v-text-field
                            v-model="props.item.expectedQty"
                            type="number"
                            :readonly="checkDisable('complete')"
                            @input="calculateAllExpectedCost()"
                            style="width: 150px"
                            :rules="rules.zeroQtyRules('Expected Qty')"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="props.item.actualQty"
                            type="number"
                            :readonly="
                              meta.outOrIn == 'IN'
                                ? true
                                : checkDisable('complete')
                            "
                            @input="
                              meta.outOrIn == 'OUT'
                                ? calculateOutputUnitCost(props.item)
                                : ''
                            "
                            style="width: 150px"
                            :rules="
                              meta.outOrIn == 'IN'
                                ? rules.zeroQtyRules('Actual Qty')
                                : rules.geraterThanZeroQtyRules('Actual Qty')
                            "
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="props.item.totalAmount"
                            type="number"
                            readonly
                            style="width: 180px"
                          ></v-text-field>
                        </td>
                        <td v-if="meta.outOrIn == 'OUT'">
                          <v-text-field
                            v-model="props.item.currentStockQty"
                            type="number"
                            readonly
                            style="width: 150px"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="props.item.remark"
                            type="text"
                            :readonly="checkDisable('complete')"
                            style="width: 200px"
                            :rules="rules.lengthRules(500, 'Remark')"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-btn
                            icon
                            @click="removeItem(meta.outOrIn, props.item.id)"
                            :disabled="
                              meta.outOrIn == 'OUT'
                                ? checkDisable('complete')
                                  ? true
                                  : false
                                : checkDisable('progress') &&
                                  productionHeader.id &&
                                  !props.item.isNew
                                ? true
                                : false
                            "
                          >
                            <v-icon>cancel</v-icon>
                          </v-btn>
                        </td>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-flex>
              <!--manufacturing cost list-->
              <v-flex sm12>
                <v-card>
                  <v-card-title>
                    <span class="headline font-weight-bold pr-3"
                      >Manufacturing Cost</span
                    >
                    <v-icon
                      large
                      @click="showMfgCostDialog = !showMfgCostDialog"
                      :disabled="checkDisable('finished') ? true : false"
                      >add_circle</v-icon
                    >
                    <span class="subheading pl-5 pr-2 font-weight-medium"
                      >Total Cost:
                    </span>
                    <v-chip>
                      <span>{{ totalManufacturingCost | decFormat(6) }}</span>
                    </v-chip>
                  </v-card-title>
                  <v-card-text>
                    <v-data-table
                      :headers="manufacturingCostHeaders"
                      :items="productionHeader.productionCostList"
                      class="elevation-1"
                    >
                      <template v-slot:items="props">
                        <td>
                          <v-text-field
                            v-model="props.item.manufacturingCostCode"
                            type="text"
                            :rules="rules.lengthRequiredRules(20, 'Code')"
                            readonly
                            style="width: 200px"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="props.item.manufacturingCostName"
                            type="text"
                            readonly
                            :rules="rules.lengthRequiredRules(100, 'Name')"
                            style="width: 250px"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="props.item.unitCost"
                            type="number"
                            :rules="rules.zeroUnitCostRules('Unit Cost')"
                            :readonly="checkDisable('finished')"
                            @input="initExpectedCost(props.item)"
                            style="width: 180px"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="props.item.expectedCost"
                            type="number"
                            :rules="rules.zeroUnitCostRules('Expected Cost')"
                            :readonly="checkDisable('finished')"
                            @input="initActualCost(props.item)"
                            style="width: 180px"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="props.item.actualCost"
                            type="number"
                            :rules="rules.zeroUnitCostRules('Actual Cost')"
                            :readonly="checkDisable('finished')"
                            @input="calculateTotalAmount('MFG')"
                            style="width: 180px"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="props.item.remark"
                            type="text"
                            :rules="rules.lengthRules(500, 'Remark')"
                            :readonly="checkDisable('finished')"
                            style="width: 200px"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="props.item.productionCostingIssueNo"
                            type="text"
                            readonly
                            style="width: 250px"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-btn
                            icon
                            @click="removeProductionCost(props.item.id)"
                            :disabled="checkDisable('finished') ? true : false"
                          >
                            <v-icon>cancel</v-icon>
                          </v-btn>
                        </td>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-flex>
              <!--clear & save-->
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn
                    color="error"
                    @click="clear"
                    :disabled="productionHeader.id ? true : false"
                  >
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="
                      !valid || saveLoading || checkDisable('finished')
                        ? true
                        : false
                    "
                    @click="onSave"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!-- error message dialog -->
    <v-dialog
      v-model="errorMessageBox"
      max-width="500px"
      @keydown.enter="closeErrMsgBox"
      @keydown.esc="closeErrMsgBox"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="closeErrMsgBox"> Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--production order dialog-->
    <production-order-dialog
      :showDialog="showProductionOrderDialog"
      :params="{
        fromDate: currentDate,
        toDate: currentDate,
        shopId: this.productionHeader.shopId,
        stockWarehouseId: productionHeader.productionWarehouseId,
        stockBinId: this.productionHeader.productionBinId,
        status: 'CONFIRM',
        productionType: 'WITHOUT_PRODUCTION',
        showShopFilter: false,
        showStatusFilter: false,
        isAddDetails: true,
        isAddUnits: true,
      }"
      @close="closeProductionOrderDialog"
    ></production-order-dialog>

    <!--product list dialog-->
    <multi-select-product-list-dialog
      :showDialog="showProductDialog"
      :params="{
        status: 'ACTIVE',
        stockWarehouseId: productStockWarehouseId,
        stockBinId: productStockBinId,
      }"
      @close="closeProductDialog"
    ></multi-select-product-list-dialog>

    <!--multi select emr list dialog-->
    <MultiSelectEMRDialog
      :showDialog="showMultiEMRDialog"
      :selectedList="emrType == 'EMR' ? selectedEmrList : selectedRmrList"
      :params="{
        fromDate: currentDate,
        toDate: currentDate,
        shopId: this.productionHeader.shopId,
        stockWarehouseId: productionHeader.productionWarehouseId,
        stockBinId: this.productionHeader.productionBinId,
        status: 'CONFIRM',
        type: emrType,
        isAddDetails: false,
        isFinishedProduction: 'false',
        departmentId: '',
        showShopFilter: false,
        showDepartmentFilter: true,
        showStatusFilter: false,
        showDateFilter: false,
      }"
      @close="closeEMRDialog"
    ></MultiSelectEMRDialog>

    <!--single select manufacturing cost dialog-->
    <multi-select-manufacturing-cost-dialog
      :showDialog="showMfgCostDialog"
      :selectedList="selectedMfgCostList"
      :params="{ status: 'ACTIVE' }"
      @close="closeMfgCostDialog"
    ></multi-select-manufacturing-cost-dialog>

    <!--qc no dialog-->
    <QCListDialog
      :showDialog="showQCListDialog"
      :params="{
        productId: selectedProductionDetail.productId,
        status: 'PASS',
      }"
      @close="closeQCListDialog"
    ></QCListDialog>
  </v-container>
</template>

<script>
import {
  ProductionHeader,
  ProductionDetail,
  ProductionCost,
} from "../../models/model";
import { ProductionFormRules } from "../../helpers/validation-rules";
import { commonService } from "../../services/common-service";
import { productionService } from "../../services/production-service";
import { shopService } from "../../services/shop-service";
import { binService } from "../../services/bin-service";
import { departmentService } from "../../services/department-service";
import { productionItemService } from "../../services/production-item-service";
import { stockService } from "../../services/stock-service";
import ProductionOrderDialog from "../dialogs/ProductionOrderDialog";
import MultiSelectEMRDialog from "../dialogs/MultiSelectEMRDialog";
import MultiSelectManufacturingCostDialog from "../dialogs/MultiSelectManufacturingCostDialog";
import MultiSelectProductListDialog from "../dialogs/MultiSelectProductListDialog";
import QCListDialog from "../qc/QCListDialog";

export default {
  name: "ProductionDetail",
  components: {
    ProductionOrderDialog,
    MultiSelectEMRDialog,
    MultiSelectManufacturingCostDialog,
    MultiSelectProductListDialog,
    QCListDialog,
  },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    showProductionOrderDialog: false,
    showMultiEMRDialog: false,
    showProductDialog: false,
    showMfgCostDialog: false,
    showQCListDialog: false,
    breadcrumbs: [
      {
        text: "Production",
        disabled: false,
        to: "productions",
      },
      {
        text: "Production Detail",
        disabled: true,
      },
    ],
    productionCost: new ProductionCost(),
    productionDetail: new ProductionDetail(),
    selectedProductionDetail: new ProductionDetail(),
    productionHeader: new ProductionHeader(),
    oldProductionHeader: new ProductionHeader(),
    itemListMeta: [
      {
        outOrIn: "IN",
        itemList: [],
        totalAmount: 0,
      },
      {
        outOrIn: "OUT",
        itemList: [],
        totalAmount: 0,
      },
    ],
    shopList: [],
    departmentList: [],
    warehouseList: [],
    outputBinList: [],
    productionBinList: [],
    productionItemList: [],
    productionItemDetailList: [],
    selectedEmrList: [],
    selectedRmrList: [],
    oldEmrList: [],
    oldRmrList: [],
    selectedMfgCostList: [],
    status: "DRAFT",
    currentDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
    issueDate: "",
    createdDate: "",
    updatedDate: "",
    responseError: "",
    emrType: "",
    productStockWarehouseId: "",
    productStockBinId: "",
    inOrOutItem: "",
    totalManufacturingCost: 0,
    saveLoading: false,
    errorMessageBox: false,
    rules: new ProductionFormRules(),
    inHeaders: [
      { text: "Code", sortable: false },
      { text: "Product", sortable: false },
      { text: "QC No", sortable: false },
      { text: "Batch No", sortable: false },
      { text: "MFG Date", sortable: false },
      { text: "EXP Date", sortable: false },
      { text: "Unit", sortable: false },
      { text: "Unit Cost", sortable: false },
      { text: "PO Qty", sortable: false },
      { text: "PO Usage Qty", sortable: false },
      { text: "EMR Qty", sortable: false },
      { text: "EMR Usage Qty", sortable: false },
      { text: "RMR Qty", sortable: false },
      { text: "RMR Usage Qty", sortable: false },
      { text: "Actual Usage Qty", sortable: false },
      { text: "Total Amount", sortable: false },
      { text: "Remark", sortable: false },
      { text: "Action", sortable: false },
    ],
    outHeaders: [
      { text: "Code", sortable: false },
      { text: "Product", sortable: false },
      { text: "QC No", sortable: false },
      { text: "Batch No", sortable: false },
      { text: "MFG Date", sortable: false },
      { text: "EXP Date", sortable: false },
      { text: "Unit", sortable: false },
      { text: "Unit Cost", sortable: false },
      { text: "Expected Qty", sortable: false },
      { text: "Actual Qty", sortable: false },
      { text: "Total Amount", sortable: false },
      { text: "Current Stock Qty", sortable: false },
      { text: "Remark", sortable: false },
      { text: "Action", sortable: false },
    ],
    manufacturingCostHeaders: [
      { text: "Code", align: "left", sortable: false },
      { text: "Name", align: "left", sortable: false },
      { text: "Unit Cost", align: "left", sortable: false },
      { text: "Expected Cost", align: "left", sortable: false },
      { text: "Actual Cost", align: "left", sortable: false },
      { text: "Remark", align: "left", sortable: false },
      { text: "Production Costing Issue No", align: "left", sortable: false },
      { text: "Action", sortable: false },
    ],
    statusList: [],
  }),
  created() {
    this.productionHeader.shopId = this.checkRoleShop();
    this.productionHeader.productionWarehouseId = this.checkRoleWarehouse();
    this.productionHeader.outputWarehouseId = this.checkRoleWarehouse();
    this.getAllShop().then(() => {
      if (this.productionHeader.shopId) {
        this.setWarehouse();
      }
    });
    this.getActiveDepartments();

    const id = this.$route.params.id;
    if (id == "new") {
      //new production
      this.issueDate = commonService.formatDate(
        new Date().toISOString().substring(0, 10),
        "YYYY-MM-DD"
      );
      this.getActiveProductionItems();
      this.getAllProductionStatus();
    } else {
      this.getActiveProductionItems().then(() => {
        this.getProductionDetail(id);
      });
    }
  },
  methods: {
    checkRoleShop() {
      if (
        this.user.roleName == "BRANCH_ADMIN" ||
        this.user.roleName == "PRODUCTION_MANAGER"
      ) {
        return this.user.shopId;
      } else {
        return "";
      }
    },
    checkRoleWarehouse() {
      if (
        this.user.roleName == "BRANCH_ADMIN" ||
        this.user.roleName == "PRODUCTION_MANAGER"
      ) {
        return this.user.shop.warehouseId;
      } else {
        return "";
      }
    },
    getActiveDepartments() {
      departmentService
        .getDepartmentsByStatus("ACTIVE")
        .then((res) => {
          this.departmentList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAllProductionStatus() {
      //draft->draft,progress,cancel
      //progress->progress,task-complete
      //task-complete->finished
      //finished,cancel->can't change status
      return productionService
        .getAllProductionStatus()
        .then((res) => {
          let tempList = res.data;
          if (this.status == "DRAFT") {
            this.statusList = tempList
              .filter((v) => v != "TASK_COMPLETE" && v != "FINISHED")
              .map((v) => ({ label: v, value: v }));
          } else if (this.status == "PROGRESS") {
            this.statusList = tempList
              .filter((v) => v == "TASK_COMPLETE" || v == "PROGRESS")
              .map((v) => ({ label: v, value: v }));
          } else if (this.status == "TASK_COMPLETE") {
            this.statusList = tempList
              .filter((v) => v == "TASK_COMPLETE" || v == "FINISHED")
              .map((v) => ({ label: v, value: v }));
          } else {
            this.statusList = tempList
              .filter((v) => v == this.status)
              .map((v) => ({ label: v, value: v }));
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAllShop() {
      return shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clearOldItems() {
      let outItem = this.getMeta("OUT");
      outItem.itemList.forEach((out) => {
        if (!out.isNew) {
          if (!this.productionHeader.deleteProductionDetailIds) {
            this.productionHeader.deleteProductionDetailIds = [];
          }
          this.productionHeader.deleteProductionDetailIds.push(out.id);
        }
      });
      outItem.itemList = [];
      outItem.totalAmount = 0;

      let inItem = this.getMeta("IN");
      inItem.itemList.forEach((itm) => {
        if (!itm.isNew) {
          if (!this.productionHeader.deleteProductionDetailIds) {
            this.productionHeader.deleteProductionDetailIds = [];
          }
          this.productionHeader.deleteProductionDetailIds.push(itm.id);
        }
      });
      inItem.itemList = [];
      inItem.totalAmount = 0;

      this.productionHeader.productionCostList.forEach((mfgCost) => {
        mfgCost.expectedCost = 0;
        mfgCost.actualCost = 0;
      });
      this.totalManufacturingCost = 0;
    },
    setWarehouse() {
      //clear old items when shop change
      this.clearOldItems();

      this.productionHeader.productionWarehouseId = "";
      this.productionHeader.outputWarehouseId = "";
      this.warehouseList = [];
      let shop = commonService.search(
        "id",
        this.productionHeader.shopId,
        this.shopList
      );
      if (shop) {
        this.warehouseList = [shop.warehouse];
        this.productionHeader.productionWarehouseId = shop.warehouse.id;
        this.productionHeader.outputWarehouseId = shop.warehouse.id;
      }
      this.getWarehouseBin("Output");
      this.getWarehouseBin("Production");
    },
    getWarehouseBin(warehouseType) {
      let warehouseId = "";
      if (warehouseType == "Output") {
        this.productionHeader.outputBinId = "";
        this.outputBinList = [];
        if (this.productionHeader.id) {
          this.clearOldItems();
        }
        warehouseId = this.productionHeader.outputWarehouseId;
      } else if (warehouseType == "Production") {
        this.productionHeader.productionBinId = "";
        this.productionBinList = [];
        warehouseId = this.productionHeader.productionWarehouseId;
      }
      binService
        .getBinsByWarehouseAndStatus(warehouseId, "ACTIVE")
        .then((res) => {
          if (warehouseType == "Output") {
            this.outputBinList = res.data;
          } else if (warehouseType == "Production") {
            this.productionBinList = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getActiveProductionItems() {
      return productionItemService
        .getProductionItemsByStatus("ACTIVE", true)
        .then((res) => {
          this.productionItemList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeProductionItem() {
      this.productionHeader.productionItemDetailId = "";
      this.productionHeader.wipPercent = 0;
      this.productionItemDetailList = [];
      //set all actual cost=0 for manufacturing cost list because of wipPercent = 0
      this.productionHeader.productionCostList.forEach(
        (mfgCost) => (mfgCost.actualCost = 0)
      );
      this.totalManufacturingCost = 0;
      this.calculateAllOutputUnitCost();

      let productionItem = commonService.search(
        "id",
        this.productionHeader.productionItemId,
        this.productionItemList
      );
      if (productionItem) {
        this.productionItemDetailList = productionItem.productionItemDetailList;
      }
    },
    changeWIPStatus() {
      this.productionHeader.wipPercent = 0;
      let productionItemDetail = commonService.search(
        "id",
        this.productionHeader.productionItemDetailId,
        this.productionItemDetailList
      );
      if (productionItemDetail) {
        this.productionHeader.wipPercent = productionItemDetail.percentage;
        //calculate all actual cost of manufacturing cost list because of wipPercent changes
        this.totalManufacturingCost = 0;
        this.productionHeader.productionCostList.forEach((mfgCost) => {
          mfgCost.actualCost = parseFloat(
            (mfgCost.expectedCost * this.productionHeader.wipPercent).toFixed(6)
          );
          this.totalManufacturingCost += mfgCost.actualCost;
        });
        this.totalManufacturingCost = parseFloat(
          this.totalManufacturingCost.toFixed(6)
        );
        this.calculateAllOutputUnitCost();
      }
    },
    initExpectedCost(manufacturingCost) {
      manufacturingCost.expectedCost = 0;
      this.getMeta("OUT").itemList.forEach((outItem) => {
        manufacturingCost.expectedCost +=
          manufacturingCost.unitCost * outItem.expectedQty;
      });
      manufacturingCost.expectedCost = parseFloat(
        manufacturingCost.expectedCost.toFixed(6)
      );
      this.initActualCost(manufacturingCost);
    },
    initActualCost(manufacturingCost) {
      manufacturingCost.actualCost = parseFloat(
        (
          this.productionHeader.wipPercent * manufacturingCost.expectedCost
        ).toFixed(6)
      );
      this.calculateTotalAmount("MFG");
    },
    checkDisable(type) {
      if (type == "finished") {
        return this.status == "CANCEL" || this.status == "FINISHED";
      } else if (type == "complete") {
        return (
          this.status == "TASK_COMPLETE" ||
          this.status == "CANCEL" ||
          this.status == "FINISHED"
        );
      } else if (type == "progress") {
        return (
          this.status == "PROGRESS" ||
          this.status == "TASK_COMPLETE" ||
          this.status == "CANCEL" ||
          this.status == "FINISHED"
        );
      }
    },
    getMeta(outOrIn) {
      let meta = { itemList: [] };
      if (outOrIn == "OUT") meta = this.itemListMeta[1];
      else if (outOrIn == "IN") meta = this.itemListMeta[0];
      return meta;
    },
    generateId(inOrOut) {
      let duplicateFlag = true;
      let id;

      // generate random id until it's unique
      while (duplicateFlag) {
        id = Math.floor(Math.random() * 9999 + 1);

        // find if id is duplicated
        let duplicateDetail;
        if (inOrOut == "IN" || inOrOut == "OUT") {
          duplicateDetail = this.getMeta(inOrOut).itemList.find(
            (d) => d.id == id
          );
        } else if (inOrOut == "MFG") {
          duplicateDetail = this.productionHeader.productionCostList.find(
            (d) => d.id == id
          );
        }
        if (!duplicateDetail) duplicateFlag = false;
      }
      return id;
    },
    getIndex(id, inOrOut) {
      if (inOrOut == "IN" || inOrOut == "OUT") {
        return this.getMeta(inOrOut)
          .itemList.map((d) => d.id)
          .indexOf(id);
      } else if (inOrOut == "MFG") {
        return this.productionHeader.productionCostList
          .map((d) => d.id)
          .indexOf(id);
      }
    },
    addProductionCost() {
      // deep copy
      let productionCost = JSON.parse(JSON.stringify(this.productionCost));

      // if no id, add temporary id for key
      if (!productionCost.id) {
        productionCost.isNew = true;
        productionCost.id = this.generateId("MFG");
      }
      return productionCost;
    },
    closeMfgCostDialog(newSelectedList) {
      newSelectedList.forEach((v) => this.selectedMfgCostList.push(v));
      newSelectedList.forEach((mfgCost) => {
        let existMfgCost = this.productionHeader.productionCostList.find(
          (v) => v.manufacturingCostId == mfgCost.id
        );
        if (typeof existMfgCost == "undefined") {
          this.manufacturingCost = this.addProductionCost();
          this.manufacturingCost.manufacturingCostId = mfgCost.id;
          this.manufacturingCost.manufacturingCostCode = mfgCost.code;
          this.manufacturingCost.manufacturingCostName = mfgCost.name;
          this.manufacturingCost.unitCost = 0;
          this.manufacturingCost.expectedCost = 0;
          this.manufacturingCost.actualCost = 0;
          this.productionHeader.productionCostList.unshift(
            this.manufacturingCost
          );
        }
      });
      this.showMfgCostDialog = !this.showMfgCostDialog;
    },
    removeProductionCost(deleteId) {
      const index = this.getIndex(deleteId, "MFG");
      const deleteMfgCostId =
        this.productionHeader.productionCostList[index].manufacturingCostId;
      if (!this.productionHeader.productionCostList[index].isNew) {
        if (!this.productionHeader.deleteProductionCostIds) {
          this.productionHeader.deleteProductionCostIds = [];
        }
        this.productionHeader.deleteProductionCostIds.push(deleteId);
      }
      this.$delete(this.productionHeader.productionCostList, index);
      this.calculateTotalAmount("MFG");

      //delete for multi pick mfg cost dialog
      const deleteMfgCostIndex = this.selectedMfgCostList
        .map((d) => d.id)
        .indexOf(deleteMfgCostId);
      this.$delete(this.selectedMfgCostList, deleteMfgCostIndex);
    },
    showDialog(dialogName) {
      if (
        this.productionHeader.shopId &&
        this.productionHeader.productionWarehouseId &&
        this.productionHeader.productionBinId
      ) {
        if (dialogName == "poNo") {
          this.showProductionOrderDialog = !this.showProductionOrderDialog;
        } else if (dialogName == "emrNo") {
          this.emrType = "EMR";
          this.showMultiEMRDialog = !this.showMultiEMRDialog;
        } else if (dialogName == "rmrNo") {
          this.emrType = "RMR";
          this.showMultiEMRDialog = !this.showMultiEMRDialog;
        } else if (dialogName == "product") {
          if (this.inOrOutItem == "IN") {
            this.productStockWarehouseId =
              this.productionHeader.productionWarehouseId;
            this.productStockBinId = this.productionHeader.productionBinId;
          } else if (this.inOrOutItem == "OUT") {
            this.productStockWarehouseId = "";
            this.productStockBinId = "";
          }
          this.showProductDialog = !this.showProductDialog;
        }
      } else {
        this.errorMessageBox = true;
        if (!this.productionHeader.shopId) {
          this.responseError = "Shop is Required.";
        } else if (!this.productionHeader.productionWarehouseId) {
          this.responseError = "Production Warehouse is Required.";
        } else if (!this.productionHeader.productionBinId) {
          this.responseError = "Production Bin is Required.";
        }
      }
    },
    openQCListDialog(productionDetail) {
      this.selectedProductionDetail = productionDetail;
      this.showQCListDialog = !this.showQCListDialog;
    },
    clearQCno(productionDetail) {
      productionDetail.qcNo = "";
      productionDetail.batchNo = "";
      productionDetail.mfgDate = "";
      productionDetail.mfgDateInMilliSeconds = "";
      productionDetail.expDate = "";
      productionDetail.expDateInMilliSeconds = "";
      if (productionDetail.type == "INPUT") {
        this.calculateIngredientUnitCost(productionDetail);
      }
    },
    closeQCListDialog(qc) {
      if (!(JSON.stringify(qc) === "{}")) {
        this.selectedProductionDetail.qcNo = qc.qcNo;
        this.selectedProductionDetail.batchNo = qc.batchLotNo;
        if (qc.mfgDateInMilliSeconds) {
          this.selectedProductionDetail.mfgDate =
            commonService.millisecondToDate(
              qc.mfgDateInMilliSeconds,
              "YYYY-MM-DD"
            );
        }
        if (qc.expDateInMilliSeconds) {
          this.selectedProductionDetail.expDate =
            commonService.millisecondToDate(
              qc.expDateInMilliSeconds,
              "YYYY-MM-DD"
            );
        }

        if (this.selectedProductionDetail.type == "INPUT") {
          this.calculateIngredientUnitCost(this.selectedProductionDetail);
        }
      }
      this.showQCListDialog = !this.showQCListDialog;
    },
    calculateIngredientUnitCost(productionDetail) {
      let wacCost = this.searchWacCost(
        productionDetail.stockProducts,
        productionDetail.qcNo,
        productionDetail.batchNo,
        productionDetail.expDate,
        productionDetail.mfgDate
      );
      productionDetail.unitCost = productionDetail.factor * wacCost;

      this.calculateTotalAmount("IN");
      this.calculateAllOutputUnitCost();
    },
    searchWacCost(stockProductList, qcNo, batchNo, expDate, mfgDate) {
      let stock = stockProductList.find(
        (st) =>
          st.qcNo == qcNo &&
          st.batchNo == batchNo &&
          st.expDate == expDate &&
          st.mfgDate == mfgDate
      );
      if (stock) {
        return Number(stock.wacCost);
      } else {
        return 0;
      }
    },
    initUnitCost(productionDetail, factorUnitName) {
      let productUnit = commonService.search(
        "factorUnitName",
        factorUnitName,
        productionDetail.productUnits
      );
      if (productUnit) {
        productionDetail.productUnitId = productUnit.id;
        productionDetail.factorUnitName = productUnit.factorUnitName;
        productionDetail.factor = productUnit.factor;
      }

      if (productionDetail.type == "INPUT") {
        this.calculateIngredientUnitCost(productionDetail);
      }
    },
    calculateAllOutputUnitCost() {
      //calculate output unit cost
      let totalInAmount = this.getMeta("IN").totalAmount;
      /*this.getMeta("IN").itemList.forEach(
        (v) => (totalInAmount += v.factor * v.unitCost * v.actualQty)
      );*/

      this.getMeta("OUT").itemList.forEach((v) => {
        if (v.actualQty > 0) {
          v.unitCost = parseFloat(
            (
              (this.totalManufacturingCost + totalInAmount) /
              v.actualQty
            ).toFixed(6)
          );
        } else {
          v.unitCost = 0;
        }
      });
      this.calculateTotalAmount("OUT");
    },
    changeUnitCost(inOrOut) {
      if (inOrOut == "IN") {
        this.calculateTotalAmount(inOrOut);
        this.calculateAllOutputUnitCost();
      } else if (inOrOut == "OUT") {
        this.calculateTotalAmount(inOrOut);
      }
    },
    calculateAllExpectedCost() {
      let outMeta = this.getMeta("OUT");
      this.totalManufacturingCost = 0;
      this.productionHeader.productionCostList.forEach((mfgCost) => {
        mfgCost.expectedCost = 0;
        outMeta.itemList.forEach(
          (outItem) =>
            (mfgCost.expectedCost += mfgCost.unitCost * outItem.expectedQty)
        );
        mfgCost.expectedCost = parseFloat(mfgCost.expectedCost.toFixed(6));
        mfgCost.actualCost = parseFloat(
          (this.productionHeader.wipPercent * mfgCost.expectedCost).toFixed(6)
        );
        this.totalManufacturingCost += mfgCost.actualCost;
      });
      this.totalManufacturingCost = parseFloat(
        this.totalManufacturingCost.toFixed(6)
      );
      this.calculateAllOutputUnitCost();
    },
    calculateOutputUnitCost(productionDetail) {
      let totalInAmount = 0;
      this.getMeta("IN").itemList.forEach(
        (v) => (totalInAmount += v.factor * v.unitCost * v.actualQty)
      );
      if (productionDetail.actualQty > 0) {
        productionDetail.unitCost = parseFloat(
          (
            (this.totalManufacturingCost + totalInAmount) /
            productionDetail.actualQty
          ).toFixed(6)
        );
      } else {
        productionDetail.unitCost = 0;
      }
      this.calculateTotalAmount("OUT");
    },
    calculateTotalAmount(inOrOut) {
      if (inOrOut == "MFG") {
        this.totalManufacturingCost = 0;
        this.productionHeader.productionCostList.forEach(
          (v) => (this.totalManufacturingCost += Number(v.actualCost))
        );
        this.totalManufacturingCost = Number(
          this.totalManufacturingCost.toFixed(6)
        );
        this.calculateAllOutputUnitCost();
      } else {
        let meta = this.getMeta(inOrOut);
        meta.totalAmount = 0;
        meta.itemList.forEach((item) => {
          item.totalAmount = parseFloat(
            (item.actualQty * item.unitCost).toFixed(2)
          );
          meta.totalAmount += item.totalAmount;
        });
        meta.totalAmount = parseFloat(meta.totalAmount.toFixed(6));
      }
    },
    removeItem(outOrIn, deleteItemId) {
      const index = this.getIndex(deleteItemId, outOrIn);
      let meta = this.getMeta(outOrIn);
      if (!meta.itemList[index].isNew) {
        if (!this.productionHeader.deleteProductionDetailIds) {
          this.productionHeader.deleteProductionDetailIds = [];
        }
        this.productionHeader.deleteProductionDetailIds.push(deleteItemId);
      }
      this.$delete(meta.itemList, index);
      if (outOrIn == "OUT") {
        this.calculateAllExpectedCost();
      } else if (outOrIn == "IN") {
        this.calculateTotalAmount("IN");
        this.calculateAllOutputUnitCost();
      }
    },
    closeProductDialog(selectedList) {
      let meta = this.getMeta(this.inOrOutItem);
      selectedList.forEach((product) => {
        let productUnit = product.productUnits.find((v) => v.basicUnit == true);
        let existProduct = meta.itemList.find(
          (v) =>
            v.productId == product.id &&
            v.productUnitId == productUnit.id &&
            v.qcNo == "" &&
            v.batchNo == "" &&
            v.expDate == "" &&
            v.mfgDate == ""
        );
        if (typeof existProduct == "undefined") {
          let productionDetail = this.addProduct(product, this.inOrOutItem);
          meta.itemList.unshift(productionDetail);
        }
      });
      this.showProductDialog = !this.showProductDialog;
    },
    getProductQcBatchDateList(productionDetail) {
      productionDetail.batchNo = "";
      productionDetail.mfgDate = "";
      productionDetail.expDate = "";
      let params = {
        warehouseId: this.productionHeader.productionWarehouseId,
        binId: this.productionHeader.productionBinId,
        productId: productionDetail.productId,
        balanceType: "WITH_BALANCE",
      };
      return stockService
        .getStockQcBatchDateList(params)
        .then((res) => {
          productionDetail.stockQcNoDTOList = res.data;
          this.getQcBatchNoList(productionDetail);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getQcBatchNoList(productionDetail) {
      productionDetail.batchNo = "";
      productionDetail.mfgDate = "";
      productionDetail.expDate = "";
      let qc = productionDetail.stockQcNoDTOList.find(
        (v) => v.qcNo == productionDetail.qcNo
      );
      if (qc) {
        productionDetail.batchNoList = qc.batchNoList;
        this.getBatchDate(productionDetail);
      }
    },
    getBatchDate(productionDetail) {
      productionDetail.mfgDate = "";
      productionDetail.expDate = "";
      let batchNo = productionDetail.batchNoList.find(
        (v) => v.batchNo == productionDetail.batchNo
      );
      if (batchNo) {
        let batchDate = batchNo.qcBatchDateDTOList.find(
          (v) => v.batchNo == productionDetail.batchNo
        );
        if (batchDate) {
          productionDetail.mfgDate = batchDate.mfgDate;
          productionDetail.expDate = batchDate.expDate;
        }
      }
      this.calculateIngredientUnitCost(productionDetail);
    },
    changeQCNo(productionDetail) {
      this.getQcBatchNoList(productionDetail);
      this.calculateIngredientUnitCost(productionDetail);
    },
    changeBatchNo(productionDetail) {
      this.getBatchDate(productionDetail);
      this.calculateIngredientUnitCost(productionDetail);
    },
    addProductionDetail(inOrOut) {
      // deep copy
      let productionDetail = JSON.parse(JSON.stringify(this.productionDetail));
      productionDetail.type = inOrOut == "IN" ? "INPUT" : "OUTPUT";
      // if no id, add temporary id for key
      if (!productionDetail.id) {
        productionDetail.isNew = true;
        productionDetail.id = this.generateId(inOrOut);
      }
      return productionDetail;
    },
    addProduct(product, inOrOut) {
      let detail = this.addProductionDetail(inOrOut);
      let productUnit = product.productUnits.find((v) => v.basicUnit == true);
      if (productUnit) {
        detail.factor = productUnit.factor;
        detail.productUnitId = productUnit.id;
        detail.factorUnitName = productUnit.factorUnitName;
      }
      detail.productCode = product.code;
      detail.productName = product.name;
      detail.productId = product.id;
      detail.productUnits = product.productUnits;
      detail.qcNo = "";
      detail.batchNo = "";
      detail.mfgDate = "";
      detail.expDate = "";
      detail.poQty = 0;
      detail.poUsageQty = 0;
      detail.emrQty = 0;
      detail.emrUsageQty = 0;
      detail.rmrQty = 0;
      detail.rmrUsageQty = 0;
      detail.actualQty = 0;
      detail.expectedQty = 0;
      detail.currentStockQty = 0;
      detail.stockProducts = product.stockProducts;
      let wacCost = this.searchWacCost(
        product.stockProducts,
        detail.qcNo,
        detail.batchNo,
        detail.expDate,
        detail.mfgDate
      );
      detail.unitCost = detail.factor * wacCost;
      this.getProductQcBatchDateList(detail);
      return detail;
    },
    closeProductionOrderDialog(productionOrder) {
      if (!(JSON.stringify(productionOrder) === "{}")) {
        this.productionHeader.productionOrderNo = productionOrder.issueNo;
        this.productionHeader.productionOrderAndPoNo = productionOrder.issueNo + "/"+ productionOrder.poNo;

        //add output
        let outMeta = this.getMeta("OUT");
        let outItem = outMeta.itemList.find(
          (v) =>
            v.productId == productionOrder.productId &&
            v.productUnitId == productionOrder.productUnitId &&
            v.qcNo == "" &&
            v.batchNo == "" &&
            v.expDate == "" &&
            v.mfgDate == ""
        );
        if (typeof outItem == "undefined") {
          let outProductionDetail = this.addPOHeader(productionOrder);
          outMeta.itemList.unshift(outProductionDetail);
        } else {
          outItem.expectedQty = productionOrder.qty;
          outItem.actualQty = productionOrder.qty;
        }
        this.calculateAllExpectedCost();

        //add ingredients
        let inMeta = this.getMeta("IN");
        productionOrder.productionOrderDetailList.forEach((item) => {
          let inItem = inMeta.itemList.find(
            (v) =>
              v.productId == item.itemProductId &&
              v.productUnitId == item.productUnitId &&
              v.qcNo == item.qcNo &&
              v.batchNo == "" &&
              v.expDate == "" &&
              v.mfgDate == ""
          );
          if (typeof inItem == "undefined") {
            let inProductionDetail = this.addPOItem(item);
            inMeta.itemList.unshift(inProductionDetail);
          } else {
            inItem.poQty = item.itemQty;
          }
        });
      }
      this.showProductionOrderDialog = !this.showProductionOrderDialog;
    },
    addPOItem(item) {
      let inProductionDetail = this.addProductionDetail("IN");
      inProductionDetail.productCode = item.itemProductCode;
      inProductionDetail.productName = item.itemProductName;
      inProductionDetail.productId = item.itemProductId;
      inProductionDetail.productUnits = item.productUnits;
      inProductionDetail.productUnitId = item.productUnitId;
      inProductionDetail.factorUnitName = item.factorUnitName;
      inProductionDetail.qcNo = item.qcNo;
      inProductionDetail.batchNo = "";
      inProductionDetail.mfgDate = "";
      inProductionDetail.expDate = "";
      inProductionDetail.poQty = item.itemQty;
      inProductionDetail.poUsageQty = 0;
      inProductionDetail.emrQty = 0;
      inProductionDetail.emrUsageQty = 0;
      inProductionDetail.rmrQty = 0;
      inProductionDetail.rmrUsageQty = 0;
      inProductionDetail.actualQty = 0;
      inProductionDetail.expectedQty = 0;
      inProductionDetail.remark = "";
      let productUnit = item.productUnits.find(
        (v) => v.id == item.itemProductUnitId
      );
      if (productUnit) {
        inProductionDetail.factor = productUnit.factor;
      }
      inProductionDetail.stockProducts = item.stockProducts;
      inProductionDetail.stockQcNoDTOList = item.stockQcNoDTOList;
      inProductionDetail.batchNoList = item.batchNoList;
      this.getBatchDate(inProductionDetail);
      let wacCost = this.searchWacCost(
        item.stockProducts,
        inProductionDetail.qcNo,
        inProductionDetail.batchNo,
        inProductionDetail.expDate,
        inProductionDetail.mfgDate
      );
      inProductionDetail.unitCost = inProductionDetail.factor * wacCost;

      return inProductionDetail;
    },
    addPOHeader(header) {
      let outProductionDetail = this.addProductionDetail("OUT");
      outProductionDetail.productCode = header.productCode;
      outProductionDetail.productName = header.productName;
      outProductionDetail.productId = header.productId;
      outProductionDetail.productUnits = header.productUnits;
      outProductionDetail.productUnitId = header.productUnitId;
      outProductionDetail.factorUnitName = header.factorUnitName;
      outProductionDetail.qcNo = "";
      outProductionDetail.batchNo = "";
      outProductionDetail.mfgDate = "";
      outProductionDetail.expDate = "";
      outProductionDetail.poQty = 0;
      outProductionDetail.poUsageQty = 0;
      outProductionDetail.emrQty = 0;
      outProductionDetail.emrUsageQty = 0;
      outProductionDetail.rmrQty = 0;
      outProductionDetail.rmrUsageQty = 0;
      outProductionDetail.unitCost = 0;
      outProductionDetail.actualQty = header.qty;
      outProductionDetail.expectedQty = header.qty;
      outProductionDetail.remark = "";
      return outProductionDetail;
    },
    onSave() {
      if (this.$refs.form.validate()) {
        if (!this.saveLoading) {
          this.saveLoading = true;
          let productionObj = this.productionHeader;

          //convert to milliseconds
          productionObj.issueDateInMilliSeconds =
            commonService.convertToMilliseconds(this.issueDate);
          productionObj.productionDetailList = [];

          //convert mfg and exp date to milliseconds
          //delete auto generate id if item is new
          this.itemListMeta[0].itemList.forEach((inItem) => {
            if (inItem.isNew) inItem.id = null;

            if (inItem.mfgDate) {
              inItem.mfgDateInMilliSeconds =
                commonService.convertToMilliseconds(inItem.mfgDate);
            }

            if (inItem.expDate) {
              inItem.expDateInMilliSeconds =
                commonService.convertToMilliseconds(inItem.expDate);
            }

            productionObj.productionDetailList.push(inItem);
          });
          this.itemListMeta[1].itemList.forEach((outItem) => {
            if (outItem.isNew) outItem.id = null;

            if (outItem.mfgDate) {
              outItem.mfgDateInMilliSeconds =
                commonService.convertToMilliseconds(outItem.mfgDate);
            }

            if (outItem.expDate) {
              outItem.expDateInMilliSeconds =
                commonService.convertToMilliseconds(outItem.expDate);
            }

            productionObj.productionDetailList.push(outItem);
          });

          //delete auto generate id if cost is new
          productionObj.productionCostList.forEach((mfgCost) => {
            if (mfgCost.isNew) mfgCost.id = null;
          });
          productionService
            .saveProduction(productionObj)
            .then((res) => {
              if (res) {
                this.goBack();
              }
            })
            .catch((err) => {
              if (err.response.data) {
                this.responseError = err.response.data.message;
                this.errorMessageBox = true;
              }
              this.saveLoading = false;
            });
        }
      }
    },
    closeErrMsgBox() {
      this.errorMessageBox = false;
      this.responseError = "";
    },
    clear() {
      this.$refs.form.resetValidation();
      this.responseError = "";
      if (!this.productionHeader.id) {
        this.productionHeader = new ProductionHeader();
        this.productionHeader.shopId = this.checkRoleShop();
        this.productionHeader.productionWarehouseId = this.checkRoleWarehouse();
        this.productionHeader.outputWarehouseId = this.checkRoleWarehouse();
        this.itemListMeta[0].itemList = [];
        this.itemListMeta[0].totalAmount = 0;
        this.itemListMeta[1].itemList = [];
        this.itemListMeta[1].totalAmount = 0;
        this.totalManufacturingCost = 0;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    addEMRItem(detail, type) {
      let inProductionDetail = this.addProductionDetail("IN");
      inProductionDetail.productCode = detail.productCode;
      inProductionDetail.productName = detail.productName;
      inProductionDetail.productId = detail.productId;
      inProductionDetail.productUnits = detail.productUnits;
      inProductionDetail.productUnitId = detail.productUnitId;
      inProductionDetail.factorUnitName = detail.factorUnitName;
      inProductionDetail.qcNo = "";
      inProductionDetail.batchNo = "";
      inProductionDetail.mfgDate = "";
      inProductionDetail.expDate = "";
      inProductionDetail.poQty = 0;
      inProductionDetail.poUsageQty = 0;
      if (type == "EMR") {
        inProductionDetail.emrQty = detail.qty - detail.usageQty;
        inProductionDetail.emrUsageQty = 0;
        inProductionDetail.rmrQty = 0;
        inProductionDetail.rmrUsageQty = 0;
      } else if (type == "RMR") {
        inProductionDetail.emrQty = 0;
        inProductionDetail.emrUsageQty = 0;
        inProductionDetail.rmrQty = detail.qty;
        inProductionDetail.rmrUsageQty = 0;
      }
      inProductionDetail.actualQty = 0;
      let productUnit = detail.productUnits.find(
        (v) => v.id == detail.productUnitId
      );
      if (productUnit) {
        inProductionDetail.factor = productUnit.factor;
      }
      inProductionDetail.stockProducts = detail.stockProducts;
      inProductionDetail.stockQcNoDTOList = detail.stockQcNoDTOList;
      inProductionDetail.batchNoList = detail.batchNoList;
      this.getBatchDate(inProductionDetail);
      let wacCost = this.searchWacCost(
        detail.stockProducts,
        inProductionDetail.qcNo,
        inProductionDetail.batchNo,
        inProductionDetail.expDate,
        inProductionDetail.mfgDate
      );
      inProductionDetail.unitCost = inProductionDetail.factor * wacCost;
      return inProductionDetail;
    },
    closeEMRDialog(newSelectedList) {
      newSelectedList.forEach((emr) => {
        if (emr.type == "EMR") {
          this.selectedEmrList.push(emr);
        } else if (emr.type == "RMR") {
          this.selectedRmrList.push(emr);
        }
      });
      this.productionHeader.emrIds = this.selectedEmrList
        .map((emr) => {
          return emr.id;
        })
        .join(",");
      this.productionHeader.rmrIds = this.selectedRmrList
        .map((emr) => {
          return emr.id;
        })
        .join(",");
      this.productionHeader.emrNos = this.selectedEmrList
        .map((emr) => {
          return emr.issueNo;
        })
        .join(",");
      this.productionHeader.rmrNos = this.selectedRmrList
        .map((emr) => {
          return emr.issueNo;
        })
        .join(",");

      //add ingredient
      let inMeta = this.getMeta("IN");
      newSelectedList.forEach((emr) => {
        emr.emrDetailList.forEach((detail) => {
          if (detail.qty > detail.usageQty) {
            let inItem = inMeta.itemList.find(
              (v) =>
                v.productId == detail.productId &&
                v.productUnitId == detail.productUnitId &&
                v.qcNo == "" &&
                v.batchNo == "" &&
                v.expDate == "" &&
                v.mfgDate == ""
            );
            if (typeof inItem == "undefined") {
              let inProductionDetail = this.addEMRItem(detail, emr.type);
              inMeta.itemList.unshift(inProductionDetail);
            } else {
              if (emr.type == "EMR") {
                inItem.emrQty += detail.qty - detail.usageQty;
              } else if (emr.type == "RMR") {
                inItem.rmrQty += detail.qty - detail.usageQty;
              }
            }
          }
        });
      });

      this.showMultiEMRDialog = !this.showMultiEMRDialog;
    },
    clearEMRNos(emr) {
      if (emr.type == "EMR") {
        const index = this.selectedEmrList.map((d) => d.id).indexOf(emr.id);
        this.$delete(this.selectedEmrList, index);
        this.productionHeader.emrIds = this.selectedEmrList
          .map((emr) => {
            return emr.id;
          })
          .join(",");
        this.productionHeader.emrNos = this.selectedEmrList
          .map((emr) => {
            return emr.issueNo;
          })
          .join(",");
      } else if (emr.type == "RMR") {
        const index = this.selectedRmrList.map((d) => d.id).indexOf(emr.id);
        this.$delete(this.selectedRmrList, index);
        this.productionHeader.rmrIds = this.selectedRmrList
          .map((rmr) => {
            return rmr.id;
          })
          .join(",");
        this.productionHeader.rmrNos = this.selectedRmrList
          .map((rmr) => {
            return rmr.issueNo;
          })
          .join(",");
      }
    },
    getProductionDetail(id) {
      let params = { isAddDetail: true, isAddCostDetail: true };
      productionService
        .getProductionDetail(id, params)
        .then((res) => {
          this.productionHeader = res.data;
          this.productionHeader.productionDetailList.forEach((detailItem) => {
            //convert milliseconds to date
            if (detailItem.expDateInMilliSeconds) {
              detailItem.expDate = commonService.millisecondToDate(
                detailItem.expDateInMilliSeconds,
                "YYYY-MM-DD"
              );
            } else {
              detailItem.expDate = "";
            }

            if (detailItem.mfgDateInMilliSeconds) {
              detailItem.mfgDate = commonService.millisecondToDate(
                detailItem.mfgDateInMilliSeconds,
                "YYYY-MM-DD"
              );
            } else {
              detailItem.mfgDate = "";
            }

            if (detailItem.type == "INPUT") {
              this.itemListMeta[0].itemList.push(detailItem);
            } else {
              this.itemListMeta[1].itemList.push(detailItem);
            }
          });

          //set status
          this.status = res.data.status;
          this.getAllProductionStatus();

          //calculate total amount
          if (this.status == "TASK_COMPLETE" || this.status == "FINISHED" || this.status == "CANCEL") {
            this.calculateTotalAmount("OUT");
            this.calculateTotalAmount("IN");
            this.totalManufacturingCost = 0;
            this.productionHeader.productionCostList.forEach(
              (v) => (this.totalManufacturingCost += Number(v.actualCost))
            );
            this.totalManufacturingCost = Number(
              this.totalManufacturingCost.toFixed(6)
            );
          } else {
            this.calculateTotalAmount("MFG");
            this.calculateTotalAmount("IN");
            this.calculateAllOutputUnitCost();
          }

          //convert milliseconds to date(production header)
          this.issueDate = commonService.millisecondToDate(
            this.productionHeader.issueDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.createdDate = commonService.millisecondToDate(
            this.productionHeader.createdDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.millisecondToDate(
            this.productionHeader.updatedDateInMilliSeconds,
            "YYYY-MM-DD"
          );

          //if register data is inactive, add inactive data to list for showing UI
          if (this.productionHeader.outputWarehouse) {
            this.warehouseList.push(this.productionHeader.outputWarehouse);
          }
          if (this.productionHeader.outputBin) {
            this.outputBinList.push(this.productionHeader.outputBin);
          }
          if (this.productionHeader.productionBin) {
            this.productionBinList.push(this.productionHeader.productionBin);
          }
          if (this.productionHeader.productionItem) {
            this.productionItemList.push(this.productionHeader.productionItem);
          }

          //set shop's warehouse list
          let shop = commonService.search(
            "id",
            this.productionHeader.shopId,
            this.shopList
          );
          if (shop) {
            this.warehouseList = [shop.warehouse];
          }

          //set warehouse bin
          binService
            .getBinsByWarehouseAndStatus(
              this.productionHeader.productionWarehouseId,
              "ACTIVE"
            )
            .then((res) => {
              this.outputBinList = res.data;
              this.productionBinList = res.data;
            })
            .catch((err) => {
              console.log(err);
            });

          //set wip status list
          let productionItem = commonService.search(
            "id",
            this.productionHeader.productionItemId,
            this.productionItemList
          );
          if (productionItem) {
            this.productionItemDetailList =
              productionItem.productionItemDetailList;
          }

          this.selectedEmrList = res.data.selectedEmrList;
          this.selectedRmrList = res.data.selectedRmrList;
          this.selectedMfgCostList = res.data.selectedMfgCostList;
          if (this.status != "DRAFT") {
            this.oldEmrList = JSON.parse(
              JSON.stringify(res.data.selectedEmrList)
            );
            this.oldRmrList = JSON.parse(
              JSON.stringify(res.data.selectedRmrList)
            );
          }

          //deep copy
          this.oldProductionHeader = JSON.parse(JSON.stringify(res.data));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /*clearPoNo() {
      this.productionHeader.productionOrderNo = "";
      //clear ingredient
      let inMeta = this.getMeta("IN");
      inMeta.itemList.forEach((item) => {
        item.poQty = 0;

        if (item.emrQty == 0 && item.rmrQty == 0) {
          const index = this.getIndex(item.id, "IN");
          console.log("index=", index);
          if (!item.isNew) {
            if (!this.productionHeader.deleteProductionDetailIds) {
              this.productionHeader.deleteProductionDetailIds = [];
            }
            this.productionHeader.deleteProductionDetailIds.push(item.id);
          }
          //this.$delete(inMeta.itemList, index);
        }
      });

      let outItem = this.getMeta("OUT");
      if (this.productionHeader.id) {
        outItem.itemList.forEach((item) => {
          if (!item.isNew) {
            if (!this.productionHeader.deleteProductionDetailIds) {
              this.productionHeader.deleteProductionDetailIds = [];
            }
            this.productionHeader.deleteProductionDetailIds.push(item.id);
          }
        });
      }
      outItem.itemList = [];
      outItem.totalAmount = 0;
      this.calculateAllExpectedCost();
      if (this.productionHeader.id) {
        this.calculateAllOutputUnitCost();
      }
    },*/
  },
};
</script>

